import { mode } from '@chakra-ui/theme-tools';

const MiniCalendar = {
  baseStyle: (props: any) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 'max-content',
    height: 'max-content',
    bg: mode('white', 'navy.800')(props),
    boxShadow: mode(
      '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
      'unset',
    )(props),
  }),
  sizes: {
    sm: {
      padding: '12px 10px',
      borderRadius: '16px',
      fontSize: 'xs',
    },
    md: {
      padding: '20px 15px',
      borderRadius: '20px',
      fontSize: 'sm',
    },
    lg: {
      padding: '28px 20px',
      borderRadius: '24px',
      fontSize: 'md',
    },
  },
  defaultProps: {
    size: 'md',
  },
};

export const CalendarComponent = {
  components: {
    MiniCalendar,
  },
};
